import { useState, useCallback } from "react";

import { platforms, capitalizeFirstLetter } from "./utils";

export const BundleDownloadButton = ({ release, isStandalone = true, showIcon = true, children }) => (
  <a
    className={"btn btn-md rounded d-inline-flex align-items-center" + (isStandalone ? " btn-primary" : " btn-link")}
    href={release.bundleFileUrl}
    title={`Download oblac-drives_${release.version}.odbx`}
  >
    {children ? children : "Download Release Bundle (.odbx)"}
  </a>
);

const DownloadDropdown = ({ release, os }) => {
  const [oses] = useState({
    current: os,
    list: platforms,
  });

  const PrimaryDownloadButton = useCallback(
    () =>
      !oses.current ? null : (
        <a
          href={release[`${oses.current}AppUrl`]}
          title={`Download ${release[`${oses.current}AppHandle`]}`}
          className="btn btn-md btn-primary rounded d-inline-flex align-items-center"
        >
          Download for {capitalizeFirstLetter(oses.current)}
        </a>
      ),
    [release, oses]
  );

  const SecondaryDownloadLinks = useCallback(() => {
    return (
      <>
        {oses.list
          .filter((name) => (oses.current ? name !== oses.current : name))
          .map((name) => (
            <a
              href={release[`${name}AppUrl`]}
              title={`Download ${release[`${name}AppHandle`]}`}
              className={
                "btn btn-md rounded d-inline-flex align-items-center" +
                (oses.current ? " btn-outline-secondary" : " btn-secondary")
              }
              key={name}
            >
              Download for {capitalizeFirstLetter(name)}
            </a>
          ))}
      </>
    );
  }, [oses, release]);

  return (
    <span className="btn-group" style={{ gap: "0.5rem" }}>
      <BundleDownloadButton release={release} isStandalone={false} />
      {SecondaryDownloadLinks()}
      {PrimaryDownloadButton()}
    </span>
  );
};

export default DownloadDropdown;
